import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import BaseFormField from '@/components/atoms/FormField';

interface FormFieldProps {
    htmlFor?: string;
    label: string;
    optional?: boolean;
    // Inline affordance rendered on the label row, right-aligned (e.g. the
    // fish-group name "Suggest" button).
    labelAction?: ReactNode;
    error?: string | null;
    // Contextual message shown below the input that is *not* tied to a
    // validation error (e.g. "no empty cages available"). Rendered alongside
    // the validation error when both are present.
    note?: string | null;
    children: ReactNode;
}

// Shared layout for every controlled form field in the FishGroups action
// modals: the portal FormField with this feature's "optional" wording.
export default function FormField(props: FormFieldProps) {
    const { htmlFor, label, optional, labelAction, error, note, children } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <BaseFormField
            htmlFor={htmlFor}
            label={label}
            labelSuffix={optional ? t('actions.fields.optional') : undefined}
            labelAction={labelAction}
            hint={note}
            hintTone="danger"
            error={error}>
            {children}
        </BaseFormField>
    );
}
